import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../logo.png';
import './Navigation.css';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.nav
      className={`navigation ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="nav-container">
        <Link to="/" className="logo">
          <img src={logo} alt="suceava.taxi" className="logo-image" />
        </Link>

        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <Link
            to="/"
            className={location.pathname === '/' ? 'active' : ''}
            onClick={() => setMenuOpen(false)}
          >
            Acasă
          </Link>
          <Link
            to="/terms"
            className={location.pathname === '/terms' ? 'active' : ''}
            onClick={() => setMenuOpen(false)}
          >
            Termeni
          </Link>
          <Link
            to="/privacy"
            className={location.pathname === '/privacy' ? 'active' : ''}
            onClick={() => setMenuOpen(false)}
          >
            Confidențialitate
          </Link>
          <a
            href="#download"
            className="download-btn"
            onClick={() => setMenuOpen(false)}
          >
            Descarcă Aplicația
          </a>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navigation;
